module.exports = __webpack_public_path__ + "img/personal_student_wrong_explain.4c1b6eeb.svg";